import { render, staticRenderFns } from "./FloorAreaLivingRoom.vue?vue&type=template&id=0aba37e3&"
import script from "./FloorAreaLivingRoom.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaLivingRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports